import { render, staticRenderFns } from "./RegisterBankForOrderDialog.vue?vue&type=template&id=bc444694&scoped=true"
import script from "./RegisterBankForOrderDialog.vue?vue&type=script&lang=js"
export * from "./RegisterBankForOrderDialog.vue?vue&type=script&lang=js"
import style0 from "./RegisterBankForOrderDialog.vue?vue&type=style&index=0&id=bc444694&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc444694",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc444694')) {
      api.createRecord('bc444694', component.options)
    } else {
      api.reload('bc444694', component.options)
    }
    module.hot.accept("./RegisterBankForOrderDialog.vue?vue&type=template&id=bc444694&scoped=true", function () {
      api.rerender('bc444694', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/dialog/RegisterBankForOrderDialog.vue"
export default component.exports